const allowedIssueTypeValues = ['bug', 'story', 'task', 'subtask', 'epic'];

export const getAnalyticsIssueType = (issueType?: string) => {
	const issueTypeLabel = issueType?.toLowerCase();

	return issueTypeLabel && allowedIssueTypeValues.includes(issueTypeLabel)
		? issueTypeLabel
		: 'custom';
};
